import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import {ICom0114PState, IDeptState} from '../../models/com/com0114p_model';
  
const initialState: ICom0114PState = {
    deptList : [],          // 부서목록
    selectedRowKeys : [],   // 체크박스
}

export const com0114p_Slice = createSlice({
    name: "com0114p_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            Object.assign(state, initialState);
        },
        setDeptList: (state, action:PayloadAction<IDeptState[]>) => {
            state.deptList = action.payload;
        },
        setSelectedRowKeys: (state, action:PayloadAction<string[]>) => {
            state.selectedRowKeys = action.payload;
        },
    },
});

export default com0114p_Slice.reducer;
export const Com0114pAction  = com0114p_Slice.actions;
export const Com0114pReducer = com0114p_Slice.reducer;